import React from 'react';
import './LayerSelectorMenu.css';

import { Avatar, Box, Divider, Grid, Typography } from '@mui/material';

import { BASEMAPS } from '../common/constants';
import Switch from '../common/Switch/Switch';

const LayerSelectorMenu = ({ close, onStyleUpdate, selectedLayer, toggleProperties }) => {
  const [checked, setChecked] = React.useState(true);

  return (
    <Box className="layer-selector-menu">
      <Grid container direction="row" justifyContent="space-between" alignItems="center" pl={'4px'}>
        <Grid item>
          <Typography variant="subtitle2" fontWeight={900}>
            Properties
          </Typography>
        </Grid>
        <Grid item>
          <Switch
            checked={checked}
            onClick={() => {
              setChecked(!checked);
              toggleProperties(!checked);
            }}
          />
        </Grid>
      </Grid>
      <Divider variant="middle" className="layer-selector-menu-divider" />
      <Typography variant="subtitle2" alignSelf={'start'} fontWeight={900} pl={'4px'}>
        Base Maps
      </Typography>
      <Grid
        container
        direction="row"
        alignItems="center"
        flexWrap={'nowrap'}
        spacing={2}
        paddingRight={'4px'}
      >
        {Object.values(BASEMAPS).map((basemap) => (
          <Grid
            item
            key={basemap.id}
            alignItems="center"
            display="flex"
            flexDirection={'column'}
            onClick={() => {
              onStyleUpdate(basemap);
            }}
          >
            <Avatar
              src={basemap.img}
              variant="square"
              className={`layer-selector-menu-item ${
                selectedLayer === basemap.id ? 'selected-item' : ''
              }`}
            />
            <Typography variant="caption">{basemap.name}</Typography>
          </Grid>
        ))}
      </Grid>
      <Typography
        variant="subtitle2"
        color="primary"
        fontWeight={900}
        mt={0.5}
        className="cursor-pointer"
        onClick={close}
      >
        Hide Layers
      </Typography>
    </Box>
  );
};

export default LayerSelectorMenu;
